export default "__VITE_ASSET__VwJ6a98y__"